var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#335aff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 304,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 448,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 395,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 304,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 448a24 24 0 1 0 -24 24 24 24 0 0 0 24-24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 395,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 192,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 48,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 101,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 192,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 48a24 24 0 1 1 -24-24 24 24 0 0 1 24 24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 101,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.992 472a24 24 0 0 1 -6.433-47.123 185.506 185.506 0 0 0 96.328-64.917 181.561 181.561 0 0 0 38.113-111.96c0-81.5-55.349-154.248-134.6-176.922a24 24 0 0 1 13.2-46.147 236.543 236.543 0 0 1 121 82.086 230.506 230.506 0 0 1 .276 282.283 233.819 233.819 0 0 1 -121.421 81.812 24.04 24.04 0 0 1 -6.463.888z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m456.029 488a24.512 24.512 0 0 1 -2.679-.148l-144-16a24 24 0 0 1 -20.474-30.278l40-144a24 24 0 1 1 46.248 12.848l-32.454 116.838 115.98 12.886a24 24 0 0 1 -2.621 47.854z",
    fill: "#335aff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.c4157b9e.svg";
export { ForwardRef as ReactComponent };